import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'ja',
  resources: {
    en: {
      translations: require('./locales/en.json')
    },
    ja: {
      translations: require('./locales/ja.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'ja'];

export default i18n;
